import { MediaManagerRenderedImageDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerRenderedImage } from '../interfaces/supabase/media-manager/entity';

const mediaManagerRenderedImageDataMapper = (
  dto: MediaManagerRenderedImageDto,
): MediaManagerRenderedImage => {
  const { match_id, template_id, image_url, alias_match_template, created_at, updated_at, ...rest } = dto;

  return {
    ...rest,
    matchId: match_id,
    templateId: template_id,
    imageUrl: image_url,
    aliasMatchTemplate: alias_match_template,
    createdAt: created_at,
    updatedAt: updated_at,
  };
};

export default mediaManagerRenderedImageDataMapper;
